import { GraphInputHelpers } from '@/fetching/graphql/GraphInputHelpers';
import { Ordering } from '@/types/graphql';
import { VisitOutcome } from '@/types/visit';

import {
    ContainerDefinitionType,
    defaultVisitsRowToLink,
    makeContainerDefinition,
} from '../definitions';
import { RootEntity, VisitDashboardContainer } from '../types';
import { ELEANOR_CONTAINER_KEYS } from './containerKeys/containerKeys';
import { IDashboardVariationConfig } from './types';

export const ELEANOR_HEALTH_DASHBOARD_CONFIG: IDashboardVariationConfig = {
    containers: [
        {
            key: ELEANOR_CONTAINER_KEYS.rnPositionNeeded,
            label: 'MSUD Intake Visit Needs Nursing',
            hoverText: 'Visit requires RN clinician appointment to be added.',
            tableConfig: {
                entity: RootEntity.VISIT,
                filters: {
                    services: {
                        externalIds: {
                            type: { exact: 'APPOINTMENT_TYPE_ID' },
                            value: { exact: '593' },
                        },
                    },
                    outcome: { exact: VisitOutcome.NONE },
                    AND: {
                        NOT: {
                            patient: {
                                visits: {
                                    services: { name: { iContains: 'Nursing Intake' } },
                                },
                            },
                        },
                    },
                },
                rowToLink: defaultVisitsRowToLink,
                emptyTableText: 'No new patient visits need RN positions at this time',
                ordering: { patient: { fullName: Ordering.ASC } },
            },
            defaultEnabled: true,
        } satisfies VisitDashboardContainer,
        makeContainerDefinition({
            type: ContainerDefinitionType.UNASSIGNED,
            key: ELEANOR_CONTAINER_KEYS.unassigned,
            defaultEnabled: true,
        }),
        {
            key: ELEANOR_CONTAINER_KEYS.rnPatientPayerMismatch,
            label: 'Payer Mismatch',
            tableConfig: {
                entity: RootEntity.VISIT,
                filters: {
                    clinicianAppointments: {
                        clinician: { id: { isNull: false } },
                        arePatientClinicianPayersCompatible: { exact: false },
                    },
                    effectiveDate: { gte: GraphInputHelpers.date(new Date()) },
                    outcome: { exact: VisitOutcome.NONE },
                    NOT: {
                        notesForDashboard: { iContains: 'axle-ignore-payer-mismatch' },
                    },
                },
                emptyTableText: 'No payer mismatches at this time.',
                rowToLink: defaultVisitsRowToLink,
                ordering: { patient: { fullName: Ordering.ASC } },
            },
            hoverText: 'Visits with clinician and patient payer mismatches.',
            defaultEnabled: true,
        } satisfies VisitDashboardContainer,
        makeContainerDefinition({
            type: ContainerDefinitionType.VISIT_CLINICIAN_APPOINTMENT_SYNC_ISSUES,
            key: ELEANOR_CONTAINER_KEYS.visitClinicianAppointmentSyncIssues,
            defaultEnabled: true,
        }),
        makeContainerDefinition({
            type: ContainerDefinitionType.UNSYNCED_PATIENTS,
            key: ELEANOR_CONTAINER_KEYS.unsyncedPatients,
            defaultEnabled: true,
        }),
    ],
};
